import React from 'react';
import styles from './styles/styles.module.scss';
import useWindowWidth from '../../hooks/useWindowWidth';
import SectionSwitch from '../../components/SectionSwitch';
import HomeHeader from '../../components/blocks/HomeHeader';

const HomePage = ({ context, locationData, heroData, json, lists }) => {
  const windowWidth = useWindowWidth();

  return (
    <>
      <div id="modalPortal" />
      <main className={styles.container}>
        <HomeHeader windowWidth={windowWidth} latLng={locationData.latLng} context={context} greetings={json.greetings} heroData={heroData} />
        <SectionSwitch initialSections={json.sections} context={context} windowWidth={windowWidth} lists={lists} locationData={locationData} />
      </main>
    </>
  );
};

export default HomePage;
